<template>
  <nav :class="{ 'sg-layout': shouldHideLocation }">
    <!-- Link do bieżących pomiarów (Current) widoczny tylko jeśli użytkownik ma odpowiedni dostęp -->
    <router-link
      v-if="hasAccess('CurrentMeasurements') && !shouldHideLocation"
      to="/"
      :class="[hasAccess('Vms') ? 'current-wide-link' : 'current-narrow-link', { 'router-link-active': isCurrentMeasurementActive, 'router-link-exact-active': isCurrentMeasurementActive }]"
    >
      <!-- Liczba nowych pojazdów w nawiasie tylko, gdy nie jesteśmy na głównej stronie -->
      {{ t('current-measurement').toUpperCase() }} {{ newCarsCount > 0 && $route.path !== '/' ? `(${newCarsCount})` : '' }}
    </router-link>

    <!-- Link do archiwum -->
    <router-link
      v-if="hasAccess('ArchiveMeasurements')"
      to="/archival"
      :class="[hasAccess('Vms') ? 'archive-wide-link' : 'archive-narrow-link', { 'router-link-active': isArchiveActive, 'router-link-exact-active': isArchiveActive }]"
    >
      {{ t('archive').toUpperCase() }}
    </router-link>

    <!-- Statystyki -->
    <router-link
      v-if="hasAccess('Stat')"
      to="/stat"
      :class="[hasAccess('Vms') ? 'stat-wide-link' : 'stat-narrow-link']"
    >
      {{ t('statistics').toUpperCase() }}
    </router-link>

    <!-- VMS (znaki zmiennej treści) -->
    <router-link
      v-if="hasAccess('Vms') && !shouldHideLocation"
      to="/vms"
      class="vms"
    >
      {{ t('vms').toUpperCase() }}
    </router-link>

<!--     Rozwijane menu administracyjne (np. zarządzanie użytkownikami, zgłoszenia, białe/czarne listy)-->
    <div
      class="dropdown"
      :class="[hasAccess('Vms') ? 'dropdown-wide-link' : 'dropdown-narrow-link', { active: isParentActive(['/user-management', '/user-activity', '/role-group-management', '/calibration', '/calibration-deviation', '/location-statuses', '/black-list', '/white-list', '/contact']) }]"
      v-if="canShowManagement"
    >
      <span>
        {{ t('management').toUpperCase() }}
      </span>
      <ul class="dropdown-menu">
        <li>
          <!-- Zarządzanie użytkownikami -->
          <router-link
            to="/user-management"
            :class="{ 'router-link-active': isActive('/user-management') }"
            class="white"
            v-if="hasAccess('UserManagement')"
          >
          {{ t('user-management').toUpperCase() }}
          </router-link>
        </li>
        <li>
          <!-- Aktywność użytkowników — wymaga ROLE_7 lub ROLE_8 (osobne uprawnienie
               do logów aktywności, NIE wynika z samego ROLE_19/user-managera). -->
          <router-link
            to="/user-activity"
            :class="{ 'router-link-active': isActive('/user-activity') }"
            class="white"
            v-if="hasAccess('UserActivity')"
          >
          {{ t('user-activity').toUpperCase() }}
          </router-link>
        </li>
        <li>
          <!-- Zarządzanie rolami i grupami — wymaga ROLE_20 (pełny role-manager).
               ROLE_19 daje tylko podgląd ról dla potrzeb przypisania userowi. -->
          <router-link
            to="/role-group-management"
            :class="{ 'router-link-active': isActive('/role-group-management') }"
            class="white"
            v-if="hasAccess('RoleManagement')"
          >
          {{ t('role-group-management').toUpperCase() }}
          </router-link>
        </li>
        <li>
          <!-- Zgłoszenia (ticket) -->
          <router-link
            to="/tickets"
            :class="{ 'router-link-active': isActive('/tickets') }"
            class="white"
            v-if="hasAccess('Tickets') && !shouldHideLocation"
          >
          {{ t('reports').toUpperCase() }}
          </router-link>
        </li>





        <li class="dropdown-element">
          <router-link
            to="/calibration"
            :class="{
              'router-link-active': isParentActive(['/calibration', '/calibration-deviation'])
            }"
            class="vehicles"
            v-if="hasAccess('UserManagement') && !shouldHideLocation"
          >
            {{ t('calibration').toUpperCase() }}
          </router-link>

          <ul class="dropdown-element sub-menu">
            <li>
              <router-link
                to="/calibration-deviation"
                :class="{ 'router-link-active': isActive('/calibration-deviation') }"
                class="white"
                v-if="hasAccess('UserManagement') && !shouldHideLocation"
              >
                {{ t('calibration-deviation').toUpperCase() }}
              </router-link>
            </li>
          </ul>
        </li>






        <!-- Pojazdy monitorowane (submenu: czarna/biała lista, kontakty) -->
        <li>
          <router-link
            to="/location-statuses"
            :class="{ 'router-link-active': isActive('/location-statuses') }"
            class="white"
            v-if="hasAccess('LocationStatuses')"
          >
          {{ t('location-statuses-history').toUpperCase() }}
          </router-link>
        </li>
        
        
        
        
        
        
        
        <li class="dropdown-element">
          <span
            :class="{ 'router-link-active': isParentActive(['/black-list', '/white-list', '/contact']) }"
            class="vehicles"
            v-if="hasAccess('WantedList')"
          >
          {{ t('monitored-vehicles').toUpperCase() }}
          </span>
          <ul class="dropdown-element sub-menu">
            <li>
              <!-- Czarna lista -->
              <router-link
                to="/black-list"
                :class="{ 'router-link-active': isActive('/black-list') }"
                class="white"
                v-if="hasAccess('BlackList')"
              >
              {{ t('black-list').toUpperCase() }}
              </router-link>
            </li>
            <li>
              <!-- Biała lista -->
              <router-link
                to="/white-list"
                :class="{ 'router-link-active': isActive('/white-list') }"
                class="white"
                v-if="hasAccess('WhiteList')"
              >
              {{ t('white-list').toUpperCase() }}
              </router-link>
            </li>
            <li>
              <!-- Kontakty (np. z pojazdami) -->
              <router-link
                to="/contact"
                :class="{ 'router-link-active': isActive('/contact') }"
                class="white"
                v-if="hasAccess('Contacts')"
              >
              {{ t('contacts').toUpperCase() }}
              </router-link>
            </li>
          </ul>
        </li>



      </ul>
    </div>

    <!-- Przełącznik języka (flaga + menu z innymi językami) -->
    <div class="lang-switcher" :class="{ 'sg-flag-border': shouldHideLocation }">
      <span style="cursor: pointer;" :title="currentLang.label" class="current-flag">
        <img :src="currentLang.flag" alt="flag" style="height: 20px; vertical-align: middle;" />
      </span>
      <div class="lang-dropdown">
        <span v-for="lang in otherLanguages" :key="lang.code"
          :title="lang.label"
          @click="selectLanguage(lang.code)">
          <img :src="lang.flag" alt="flag" style="height: 20px; vertical-align: middle;" class="dropdown-flag" />
        </span>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from "@/stores/user.store";
import CurrentMeasurementsService from '../services/CurrentMeasurementsService.js';
import { useI18n } from 'vue-i18n';
import { isSG } from "@/config/appVersion";

export default {
  setup() {
    const route = useRoute();
    const userStore = useUserStore();
    const { locale } = useI18n();

    // Sprawdza, czy użytkownik ma dostęp do określonej funkcji/roli
    const hasAccess = (id) => userStore.hasAccess(id);

    // Liczba nowych pojazdów (reaguje na zmiany)
    const newCarsCount = ref(CurrentMeasurementsService.getNewCarsNumber());

    // Aktualizuje liczbę nowych pojazdów co chwilę
    const updateNewCarsCount = () => { newCarsCount.value = CurrentMeasurementsService.getNewCarsNumber(); };

    // Aktywność linków (podświetlenie, pogrubienie, itp.)
    const isActive = (path) => route.path === path;
    const isCurrentMeasurementActive = computed(() => route.path === '/' || route.path.includes('/vehicle/') && !route.path.includes('vehicleArch'));
    const isArchiveActive = computed(() => route.path === '/archival' || route.path.includes('/vehicleArch/'));

    // Czy dany "parent" dropdown jest aktywny (dla podświetlenia całego bloku menu)
    const isParentActive = (paths) => {
      const adminPaths = ['/user-management', '/user-activity', '/role-group-management', '/calibration', '/calibration-deviation', '/location-statuses', '/black-list', '/white-list', '/contact'];
      if (!adminPaths.includes(route.path)) return false;
      return paths.includes(route.path);
    };

    // Definicja dostępnych języków (z flagami)
    const languages = [
      { code: 'pl', label: 'Polski', flag: require('@/assets/flags/pl.png') },
      { code: 'en', label: 'English', flag: require('@/assets/flags/uk.png') },
      { code: 'ua', label: 'Україна', flag: require('@/assets/flags/ua.png') },
      { code: 'lt', label: 'Lietuvių', flag: require('@/assets/flags/lt.png') },
      { code: 'de', label: 'Deutsch', flag: require('@/assets/flags/de.png') },
      { code: 'ro', label: 'Română', flag: require('@/assets/flags/ro.png') },
    ];

    // Wybrany język i pozostałe do wyboru
    const currentLang = computed(() => languages.find(l => l.code === locale.value) || languages[0]);
    const otherLanguages = computed(() => languages.filter(l => l.code !== locale.value));
    function selectLanguage(code) {
      locale.value = code;
      localStorage.setItem('lang', code);
    }

    const shouldHideLocation = computed(() => isSG);

    // Widoczność wrappera "Zarządzanie" — pokrywa się z faktycznymi warunkami v-if pozycji
    // wewnątrz dropdownu. Wrapper ukryty, jeśli user ma uprawnienia tylko do pozycji, które
    // są odgórnie wyłączone (wariant projektu, feature flag itd.) — żeby nie pojawiał się
    // pusty dropdown. Przy dodawaniu nowej pozycji do dropdownu aktualizuj oba miejsca:
    // template (v-if pozycji) i ten computed (gałąź odpowiadającą tej pozycji).
    const canShowManagement = computed(() => {
      // user-management — bez gating'u wariantu
      if (hasAccess('UserManagement')) return true;
      // user-activity — niezależne uprawnienie ROLE_7/8
      if (hasAccess('UserActivity')) return true;
      // role-group-management — niezależne uprawnienie ROLE_20
      if (hasAccess('RoleManagement')) return true;
      // location-statuses — bez gating'u wariantu
      if (hasAccess('LocationStatuses')) return true;
      // black-list / white-list / contact — bez gating'u wariantu
      if (hasAccess('BlackList')) return true;
      if (hasAccess('WhiteList')) return true;
      if (hasAccess('Contacts')) return true;
      // tickets — ukryte w wariantach SG-rodziny
      if (hasAccess('Tickets') && !shouldHideLocation.value) return true;
      // calibration — gated przez UserManagement, więc pokryte wyżej
      return false;
    });

    // Po zamontowaniu komponentu, co 10ms aktualizuj liczbę nowych pojazdów i ustaw język z localStorage (jeśli jest)
    onMounted(() => {
      updateNewCarsCount();
      const interval = setInterval(updateNewCarsCount, 10);
      onBeforeUnmount(() => clearInterval(interval));
      const savedLang = localStorage.getItem('lang');
      if (savedLang && locale.value !== savedLang) {
        locale.value = savedLang;
      }
    });

    return {
      hasAccess, newCarsCount, isActive, isParentActive, isCurrentMeasurementActive, isArchiveActive,
      languages, currentLang, otherLanguages, selectLanguage, shouldHideLocation, canShowManagement
    };
  },
};
</script>

<style scoped>
nav {
  display: flex;
  border-bottom: 1px solid #b9b9b9;
  background: #e6e6e6;
}

nav > * {
  min-width: 0;
}

nav a {
  display: block;
  padding: 15px;
  color: #575757;
  border-right: 1px solid #9c9b9b;
  text-decoration: none;
  background-color: #e6e6e6;
  text-align: center;
}

nav a:hover {
  background-color: #d4d4d4;
}

nav a.current-narrow-link {
  width: 280px;
  white-space: nowrap;
}

nav a.current-wide-link {
  width: 280px;
  white-space: nowrap;
}

nav a.archive-narrow-link {
  width: 198px;
}

nav a.archive-wide-link {
  width: 150px;
  white-space: nowrap;
}

nav a.stat-narrow-link {
  width: 195px;
}

nav a.stat-wide-link {
  width: 150px;
  white-space: nowrap;
}

nav a.vms {
  width: 90px;
}

nav a.router-link-active {
  color: black;
  font-weight: bold;
  background-color: #d4d4d4;
}

.dropdown {
  position: relative;
  height: 100%;
  min-width: 120px;
  flex: 1 1 0;
  min-width: 0;
}

.dropdown-narrow-link {
  width: 280px;
}

.dropdown-wide-link {
  width: 283px;
}

.dropdown-wide-link > ul {
  width: 287px;
}

.dropdown-narrow-link > ul {
  width: 283px;
}

.dropdown > span {
  display: block;
  padding: 15px;
  color: #575757;
  text-decoration: none;
  background-color: #e6e6e6;
  text-align: center;
  cursor: pointer;
  border-right: 1px solid #aeaeae;
}

.dropdown-menu {
  min-width: 120px;
  display: none;
  left: -1px;
  background: #e6e6e6;
  padding: 0;
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu li {
  list-style: none;
  margin: 0;
  padding: 0; 
  height: 100%;
}

.dropdown-menu li a {
  padding: 13px 20px;
  color: #575757;
  border-bottom: 1px solid #aeaeae;
  height: 100%;
}

.dropdown-menu li a:hover {
  background-color: #d4d4d4;
}

.dropdown-element {
  min-width: 120px;
  display: block;
  left: -1px;
  background: #e6e6e6;
  padding: 0;
}

.dropdown-element > span {
  min-width: 120px;
  display: block;
  padding: 15px;
  color: #575757;
  text-decoration: none;
  background-color: #e6e6e6;
  text-align: center;
  cursor: pointer;
  border-right: 1px solid #aeaeae;
  border-bottom: 1px solid #aeaeae;
}

.dropdown-element > span.router-link-active {
  color: black;
  font-weight: bold;
  background-color: #d4d4d4;
}

.dropdown-element:hover .sub-menu {
  display: block;
  background: #e6e6e6;
}

.sub-menu {
  display: none;
}

.dropdown-element a.vehicles {
  width: 100%;
}

nav a.router-link-active {
  color: black;
  font-weight: bold;
  background-color: #d4d4d4;
}

.dropdown.active > span {
  color: black;
  font-weight: bold;
  background-color: #d4d4d4;
}

.dropdown-menu li a.router-link-active {
  color: black;
  font-weight: bold;
  background-color: #d4d4d4;
}

.dropdown-menu li a:hover {
  background-color: #d4d4d4;
}

.white {
  background-color: white;
}

.lang-switcher {
  user-select: none;
  flex: 0 0 auto;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

nav.sg-layout .dropdown {
  flex: 0 0 auto;
}

nav.sg-layout .dropdown.dropdown-wide-link {
  width: 287px;
}

nav.sg-layout .dropdown.dropdown-narrow-link {
  width: 283px;
}

nav.sg-layout .lang-switcher {
  margin-left: auto;
}

.lang-switcher.sg-flag-border {
  border-left: 1px solid #aeaeae;
}

.lang-dropdown {
  background: rgba(255,255,255,0.85);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  min-width: 60px;
  z-index: 100;
  position: absolute;
  left: 0;
  top: 47px;
  display: none;
}

.lang-dropdown > span {
  display: block; 
  cursor:pointer; 
  font-size: 22px; 
  padding: 4px 18px; 
}

.lang-dropdown span:hover {
  background: rgba(0,0,0,0.04);
}

.lang-switcher:hover .lang-dropdown {
  display: block;
}

.current-flag {
  margin-bottom: 2px;
}

.dropdown-flag {
  padding-left: 2px;
}
</style>
